import { RegularButton, SearchInput } from 'pg-ui-library';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Arrow from 'src/assets/arrow-left-black.svg';
import useDebounce from 'src/hooks/useDebounce';
import EnrollmentTable from '../enrollment-table';
import {
  Container,
  Header,
  HeaderTitle,
  Content,
  HeaderItemLeft,
  NavTextLink,
  ArrowBack,
  CardItemContainer,
  CardHeaderWithButton,
  ActionsContainer,
  CardContent,
} from './styles';
import { EnrollmentModal } from '../enrollment-modal';

const EnrollmentHistoric: React.FC = () => {
  const [modalIsOpen, setIsOpen] = useState<boolean>(false);
  const handleModal = () => {
    setIsOpen(!modalIsOpen);
  };

  const { t } = useTranslation();
  const [searchTerm, setSearchTerm] = useState('');
  // Debounce the search term so that we only perform the search
  // after the user has stopped typing for 500ms
  const debouncedSearchTerm = useDebounce(searchTerm, 500);

  return (
    <Container>
      <Header>
        <HeaderItemLeft>
          <NavTextLink to="/benefits">
            <ArrowBack src={Arrow} />
          </NavTextLink>
          <HeaderTitle>{t('benefits.openEnrollment.title')}</HeaderTitle>
        </HeaderItemLeft>
      </Header>
      <Content>
        <CardItemContainer>
          <CardHeaderWithButton>
            <ActionsContainer>
              <SearchInput
                value={searchTerm}
                placeholder="Search..."
                handleChange={event => {
                  setSearchTerm(event.target.value);
                }}
              />
              <RegularButton onClick={handleModal}>{t('benefits.openEnrollment.addButton')}</RegularButton>
            </ActionsContainer>
          </CardHeaderWithButton>
          <CardContent>
            <EnrollmentTable searchTerm={debouncedSearchTerm} />
          </CardContent>
        </CardItemContainer>
      </Content>
      <EnrollmentModal isOpen={modalIsOpen} />
    </Container>
  );
};

export default EnrollmentHistoric;
